import { Title } from '@mantine/core';
import styled from "styled-components";

export const CustomTitle = styled(Title)`
  color: #295661;
  font-size: 24px;
  font-weight: 300;
  svg {
    margin-right: 5px;
  }
  
  a {
    cursor: pointer;
    margin-right: 20px;
    color: inherit;
    text-decoration: none;
    
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const CustomSubtitle = styled(Title)`
  color: #295661;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 20px;
`;